module.exports = __webpack_public_path__ + "static/media/wheel_spin.f099bb57.mp3";